// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"e29d7d6a","156":"f410411a"}[chunkId] + ".chunk.js";
};